import { IoChevronBack } from "react-icons/io5";
import { ProfileMenu } from "../components";

const ModuleLayout = ({
  title,
  onBack,
  headerActions,
  greeting,
  subtitle,
  showProfile = true,
  children,
}) => {
  return (
    <div className="flex flex-col min-h-[calc(100vh-2rem)]">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          {onBack && (
            <button
              onClick={onBack}
              className="cursor-pointer text-xl text-gray-600 hover:text-black"
            >
              <IoChevronBack />
            </button>
          )}
          <h1 className="font-[Poppins] font-medium text-2xl">{title}</h1>
        </div>
        <div className="flex items-center gap-2">
          {headerActions && <div>{headerActions}</div>}
          {showProfile && <ProfileMenu />}
        </div>
      </div>

      <div className="flex-1 bg-[#F7F7F7] border border-[#E5E5E5] rounded-[10px] p-5 mt-3 overflow-auto">
        {(greeting || subtitle) && (
          <div className="mb-4">
            {greeting && (
              <h2 className="font-semibold text-xl text-black">{greeting}</h2>
            )}
            {subtitle && (
              <p className="text-sm text-gray-500 mt-1">{subtitle}</p>
            )}
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default ModuleLayout;
